import { createSlice } from '@reduxjs/toolkit';
import { fetchProfile, updateProfile, fetchAboutData } from '../actions/profileAction';

const initialState = {
    isLoading: false,
    isUpdating: false,
    error: null,
    updateError: null,
    success: false,
    data: JSON.parse(localStorage.getItem('user')) || null,
    aboutData: null,
    aboutLoading: false,
};

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        resetProfileState: (state) => {
            state.isLoading = false;
            state.isUpdating = false;
            state.error = null;
            state.updateError = null;
            state.success = false;
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch Profile
            .addCase(fetchProfile.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchProfile.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload.data;
                state.error = null;
            })
            .addCase(fetchProfile.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            // Update Profile
            .addCase(updateProfile.pending, (state) => {
                state.isUpdating = true;
                state.updateError = null;
                state.success = false;
            })
            .addCase(updateProfile.fulfilled, (state, action) => {
                state.isUpdating = false;
                state.success = true;
                state.data = action.payload.data;
                state.updateError = null;
                // Update user in localStorage if needed
                const existingUser = JSON.parse(localStorage.getItem('user')) || {};
                localStorage.setItem('user', JSON.stringify({ ...existingUser, ...action.payload.data }));
            })
            .addCase(updateProfile.rejected, (state, action) => {
                state.isUpdating = false;
                state.updateError = action.payload;
                state.success = false;
            })
            // Fetch About Data
            .addCase(fetchAboutData.pending, (state) => {
                state.aboutLoading = true;
            })
            .addCase(fetchAboutData.fulfilled, (state, action) => {
                state.aboutLoading = false;
                state.aboutData = action.payload.data;
            })
            .addCase(fetchAboutData.rejected, (state) => {
                state.aboutLoading = false;
            })
            // Handle social login from login slice
            .addMatcher(
                (action) => action.type === 'login/setSocialUser',
                (state, action) => {
                    state.data = action.payload.user;
                }
            );
    },
});

export const { resetProfileState } = profileSlice.actions;
export default profileSlice.reducer;
